import { BreadcrumbsData } from '@systemeio/ui'
import { CourseBundlesLoco } from 'modules/courses/bundles/constants/course-bundles-loco'
import AddCourseModal from 'modules/courses/bundles/course-bundle/components/add-course-modal'
import CourseBundleEmptyList from 'modules/courses/bundles/course-bundle/components/course-bundle-empty-list'
import CourseBundleSkeleton from 'modules/courses/bundles/course-bundle/components/course-bundle-skeleton'
import CourseBundleTable from 'modules/courses/bundles/course-bundle/components/course-bundle-table'
import { useCourseBundle } from 'modules/courses/bundles/course-bundle/hooks/user-course-bundle'
import { CourseBundleItemInterface } from 'modules/courses/bundles/course-bundle/types/course-bundle-interface'
import { NextPage } from 'next'
import { useRouter } from 'next/router'
import BreadcrumbsDashboard from 'shared/components/breadcrumbs'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { getBaseServerSideProps } from 'shared/utils/get-base-server-side-props'

const CourseBundle: NextPage = () => {
  const { t } = useLocoTranslation()
  const router = useRouter()
  const { courseBundleId } = router.query

  const { courseBundleData, mutate } = useCourseBundle(courseBundleId as string)

  const breadcrumbsData: BreadcrumbsData[] = [
    {
      caption: t('dashboard.course_bundle.title_other'),
      href: '/courses/bundles',
      isStatic: true,
    },
    { caption: courseBundleData?.name || '' },
  ]

  const addCourseWithUpdate = async (newItem: CourseBundleItemInterface) => {
    await mutate(data => {
      if (data) {
        return {
          ...data,
          items: [...data.items, newItem],
        }
      }
    }, false)
  }

  return (
    <div className="flex flex-col">
      <div className="flex flex-col items-center justify-between gap-4 lg:flex-row lg:gap-5">
        <BreadcrumbsDashboard data={breadcrumbsData} isFetching={!courseBundleData} />
        <AddCourseModal
          addCourseWithUpdate={addCourseWithUpdate}
          courseBundleId={courseBundleId as string}
          disabled={!courseBundleData}
        />
      </div>
      {courseBundleData ? (
        courseBundleData.items.length > 0 ? (
          <CourseBundleTable items={courseBundleData.items} mutate={mutate} />
        ) : (
          <CourseBundleEmptyList
            addCourseWithUpdate={addCourseWithUpdate}
            courseBundleId={courseBundleId as string}
            disabled={!courseBundleData}
          />
        )
      ) : (
        <CourseBundleSkeleton />
      )}
    </div>
  )
}

export const getServerSideProps = getBaseServerSideProps(
  CourseBundlesLoco,
  'header.top_menu.course_bundles',
)

export default CourseBundle
